import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dropZoneWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'contents' // Adicione esta linha
  },
  dropZoneOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    borderRadius: '4px',
    border: '2px dashed #aaa',
    cursor: 'pointer',
    margin: '3px'
  },
  dropZoneContent: {
    color: 'white',
    textAlign: 'center'
  },
  dropZoneIcon: {
    fontSize: '48px',
    marginBottom: '16px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.white_100.main
  },
  dropZoneText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.white_100.main
  },
  previewContainer: {
    display: 'flex',
    gap: '12px',
    position: 'absolute',
    bottom: 66,
    left: 42,
    right: 16,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: 8,
    padding: 16,
    maxHeight: 180,
    overflowX: 'auto',
    zIndex: 1000,
    transition: theme.transitions.create(['right'], {
      // Suaviza a transição de tamanho junto com o Drawer
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  previewContainerWithDrawer: {
    right: 326 // 320px (largura estimada do drawer do contato) + 16px de espaçamento original
  },
  previewContent: {
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    scrollBehavior: 'smooth',
    ...theme.scrollbarStyles,
    maxWidth: 'calc(100% - 100px)',
    display: 'flex',
    gap: '12px',
    '&::-webkit-scrollbar': {
      width: '4px',
      height: '4px'
    }
  },
  previewImage: {
    width: '78px',
    height: '88px',
    borderRadius: '4px',
    overflow: 'hidden',
    flexShrink: 0,
    transition: 'border 0.2s ease',
    cursor: 'pointer',
    position: 'relative',
    border: '2px solid' + theme.palette.blue_300.main,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  },
  previewItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    '& $previewImage': {
      border: `2px solid ${theme.palette.blue_300.main}`
    },
    '&:hover': {
      '& $previewImage': {
        border: `2px solid ${theme.palette.blue_300.main}`
      },
      '& $previewActions': {
        display: 'flex'
      }
    }
  },
  previewInfo: {
    maxWidth: '70px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& span': {
      flex: 1,
      fontSize: '0.875rem',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  previewIcon: {
    marginRight: 8,
    color: theme.palette.blue_300.main
  },
  previewName: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  previewActions: {
    position: 'absolute',
    right: -4,
    top: 1,
    display: 'none'
  },
  progressContainer: {
    flex: 1,
    marginRight: 8
  },
  cancelButton: {
    cursor: 'pointer',
    backgroundColor: theme.palette.red_100.main,
    color: theme.palette.white_100.main,
    width: '20px',
    height: '20px',
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  uploadButtonContainer: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'center',
    position: 'sticky ',
    right: 0,
    marginLeft: 'auto',
    paddingLeft: '10px',
    zIndex: 901,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  uploadButton: {
    backgroundColor: theme.palette.blue_300.main,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    height: '40px',
    width: '40px',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: 'white'
    }
  },
  cancelButtonAllFiles: {
    backgroundColor: theme.palette.red_100.main,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    height: '40px',
    width: '40px',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: 'white'
    }
  },
  filesCount: {
    position: 'absolute',
    top: 25,
    right: -4,
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.red_100.main,
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 'bold'
  },

  imageLoadingOverlay: {
    position: 'absolute',
    pointerEvents: 'none',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px'
  },

  imageProgress: {
    color: theme.palette.white_100.main
  },

  progressPercentage: {
    color: theme.palette.white_100.main,
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: '4px'
  },

  fileIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '78px',
    height: '88px',
    position: 'relative'
  },
  fileIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px'
  },
  fileIconImage: {
    width: '78px',
    height: '88px',
    objectFit: 'contain'
  },
  fileExtension: {
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
    maxWidth: '70px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  fileLoadingOverlay: {
    position: 'absolute',
    pointerEvents: 'none',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '4px'
  },

  fileProgress: {
    color: '#fff'
  },

  dropZoneVisible: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dropZoneHidden: {
    display: 'none'
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 10000,
    '& button': {
      background: 'white',
      borderRadius: '50%',
      padding: 8
    }
  }
}))
